import { RootState } from 'handlers';
import { ShiftWizardData } from 'handlers/shiftWizard';

export const selectAvailableShifts = (state: RootState): ShiftWizardData => state.shiftWizard;

export const selectIsShiftRequested = (state: RootState): boolean => state.shiftWizard.isShiftRequested;
